module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAt0lEQVQYV1XOPYrCABDF8f+kS5XDJDlA7iCIjaKNIGy3LpapBDvBTrQSF7ZSixRb7AUyc4PFUySlZCR+gVO8KX7Fe2JmZ+CYJMkn4DxOVHUqIgtgG8fxWESa1qQNM5sAK+Cnqqp+lmWXGzxwAGyAIoqi7gtaVNWOiOzd/e8NyrLsBkGwA35foKojYA2cwjDsPcs/RGTZNM13XdfDW7mZzYC5u6+LopjkeX6fa2b/7n5I0/TrubD9V1WmSVOScYy2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/r_icon.png
// module id = Uh+2
// module chunks = 1